import React from 'react';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// 휴대폰(xs)에서 '추가' 버튼 대신 쓰는 우하단 고정 Fab. sm 이상에서는 숨김(기존 추가 버튼 사용).
// 전체 화면(목록 페이지)에서만 사용 - 다이얼로그/모달 내부에서는 쓰지 않는다.
// (KSM ksm_frontend 의 동일 컴포넌트를 레이아웃만 그대로 포팅함 - 2026-10-20)
const MobileAddFab = ({ onClick, 'aria-label': ariaLabel = '추가' }) => (
  <Fab
    color="primary"
    aria-label={ariaLabel}
    onClick={onClick}
    sx={{
      display: { xs: 'flex', sm: 'none' },
      position: 'fixed',
      right: 16,
      bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
      zIndex: (theme) => theme.zIndex.speedDial,
    }}
  >
    <AddIcon />
  </Fab>
);

export default MobileAddFab;
